import Suppliers from './Suppliers'
import PlanningTools from './PlanningTools'
import AdviceAndIdeas from './AdviceAndIdeas'
import WeddingVenues from './WeddingVenues'

export default {
  'PlanningTools': PlanningTools,
  'Suppliers': Suppliers,
  'WeddingVenues': WeddingVenues,
  'AdviceAndIdeas': AdviceAndIdeas
} as { [key: string]: () => JSX.Element }
